<template>
	<div class='relname-wrap'>
		<div class="title">实名认证须知</div>
		<div class="content">
			<p>1.在实名认证之前请您核实您填写的身份信息是否正确，如果不正确将会导致您认证不通过；</p>
			<p>2.网站暂时只支持身份证的实名认证，不支持其它证件的认证；</p>
			<p>3.实名认证是为了更加确保异议申诉和自助承诺的真实有效性，只有实名认证用户才能进行个人异议申诉和自助承诺，实名认证不会影响您的用户反馈功能。</p>
			<p>4.请您文明上网，文明发言，如出现不当言论，本网站有权利将相关信息报送司法机关处理。</p>
		</div>
	</div>
</template>

<script>

export default {
	components: {},
	data() {
		return {}
	},
	created() { },
	mounted() { },
	methods: {},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.relname-wrap {
		background-color: #fbfbfb;
		padding-bottom: 40px;
		.title,
		.content {
			width: 1280px;
			margin: 0 auto;
			text-align: left;
		}
		& > .title {
			padding: 39px 0 32px;
			text-align: center;
			font-size: 17px;
			border-bottom: 1px solid #e6eaed;
		}
		& > .content {
			& > p {
				margin-top: 20px;
				font-size: 15px;
			}
		}
	}
</style>